import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const CustomSpacing = styled.div<{
    lg?: number
    md: number
}>`
    min-height: ${({ md }) => md}px;
    width: 100%;

    ${breakPoint.desktop} {
        min-height: ${({ lg, md }) => lg ?? md}px;
    }
`

export const Wrapper = styled.form`
    height: auto;
    max-width: 434px;
`
